import { CMSLink } from '@/components/Link'
import { Media } from '@/components/Media'
import { MobileMenu } from './MobileClient'
import { ChevronsRight } from 'lucide-react'

const MobileHeader = ({
  logo,
  navItems,
  rightCta,
}: {
  logo?: any
  navItems?: any
  rightCta?: any
}) => {
  return (
    <div className="sticky bg-background py-6 px-4 shadow-md z-50 top-0 font-sans">
      <div className="flex items-center justify-between">
        <div>
          <Media
            resource={logo}
            src={logo?.url}
            alt="Titan Fence & Supply Company - Est. 2009 - Crossroads, Texas"
            imgClassName="h-16 w-auto object-contain"
            priority={true}
            quality={85}
            sizes="80px"
          />
        </div>
        <MobileMenu navItems={navItems} />

        <ul className="flex items-center">
          {rightCta?.map((item: any) => (
            <li key={item.id} className="hidden md:block">
              <div className="relative overflow-hidden group rounded-full inline-flex">
                <CMSLink
                  {...item.link}
                  className="z-10 inline-flex items-center border border-border text-foreground cursor-pointer hover:text-background font-semibold text-base tracking-wide transition-colors duration-300 group/link rounded-full px-6 py-8 bg-background hover:bg-foreground"
                >
                  <div className="w-12 h-12 rounded-full flex flex-1 items-center justify-center ml-2 bg-destructive hover:text-destructive text-background">
                    <ChevronsRight />
                  </div>
                </CMSLink>
                <div className="absolute inset-0 bg-foreground origin-center rotate-[-45deg] scale-y-0 group-hover:scale-y-[5] transition-transform duration-500 ease-in-out rounded-full z-0" />
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
export default MobileHeader
